/**
 * @author PoornaChandu
 */
import React, { Fragment,useState,useEffect } from 'react';
import { Input, Select, Popover, Col, Row, TimePicker } from 'antd';
import {
  Boxdiv,
  StyledAppdiv,
  RuleTypeSelectionDiv,
  BlockedLabelBlack,
  ConditionSelect,
  ActionSelectionDiv,
  // AddParagraph,
  LogicAddButton,
  BlankDiv,
  DeviceSelect,
  ParameterSelect,
  TagNameSelect,
  OperaterSelect,
  ValueInput,
  ButtonBoxDiv,
  // PickyStyling,
  MarginRightButton,
  OnchangeCheckbox,
  ActionCheckbox,
  TextParagraph
  // BlockedParaBlack
} from '../style';
import { actionList } from '../utils/const';
import { getCommunicationList, getGroupList, 
  // getUserprofiles,
   recipientListAPI } from '../Apicalls';
import constants from '../constants';
// import localStorage from '../../../utils/localStorage';
// import 'antd/lib/date-picker/style/css';
import { CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons';
// import history from '../../../commons/history';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
const { Option } = Select;
const { TextArea } = Input;
const Operator = [
  {
    key: 'EqualTo (==)',
    value: '=='
  },
  {
    key: 'Not EqualTo (!=)',
    value: '!='
  },
  {
    key: 'Greater Than (>)',
    value: '>'
  },
  {
    key: 'Less Than (<)',
    value: '<'
  },
  {
    key: 'Greater Than Or EqualTo (>=)',
    value: '>='
  },
  {
    key: 'Less Than Or EqualTo (<=)',
    value: '<='
  }
];
// export default function DeviceRuleView(props) {
  const DeviceTypeRule = (props) => {
    // const [sitesList, setSitesList] = useState([]);
    // const [ItemdataSource, setItemdataSource] = useState([]);
    // const [treeVisible, setTreeVisible] = useState(false);
    const [communicationType, setCommunicationType] = useState([]);
    // const [value, setValue] = useState([]);
    const [data, setData] = useState([]);
    // const [translationAction, setTranslationAction] = useState([]);
    // const [checkedValue, setCheckedValue] = useState([]);
    const [groupList, setGroupList] = useState([]);
    // const [selectHierachyLevel, setSelectHierachyLevel] = useState([]);
    // const [userProfile, setUserProfile] = useState(props.userProfile || {});
    // const [DeviceData, setDeviceData] = useState([]);
    // const [treeData, setTreeData] = useState(props.treeData || []);
    // const [selectedHierarchy, setSelectedHierarchy] = useState([]);
    const [ recipientList,setRecipientList] = useState([]);
    const [group,setGroup] = useState([]);
    const navigate = useNavigate();
    const { handleRuleType, handledeviceSelect } = props.Methods;
    useEffect(() => {
      const fetchData = async () => {
        let commlist = await getCommunicationList();
        let groupListData = await getGroupList();
        // let userProfileData = await getUserprofiles();
        let recipientData = await recipientListAPI();
        let commTypes = commlist?.data?.map((item) => { 
          let val = item.Code;
          let t1 = communicationType.push(val);
          return t1;
        } ) || [];
        
        let filteredActionList = getList(commTypes);
        setData(filteredActionList);
        // const hierarchyLevels =  userProfile &&
        // userProfile['belongsTo'] &&
        // userProfile['belongsTo']['sites'] &&
        // userProfile['belongsTo']['sites'] &&
        // userProfile['belongsTo']['sites'][localStorage.get('currentSite')]['hierarchy'];
        const group = groupListData?.[0]?.Code || '';
        setCommunicationType(commTypes);
        setGroupList(groupListData);
        // setUserProfile(userProfileData);
        // setSelectedHierarchy(hierarchyLevels);
        setRecipientList(recipientData?.data || []);
        setGroup(group);
        handleRuleType(group, 'Group');
      };
      fetchData();
    }, []); 
    
    const getList = () => {
      let filteredArray = communicationType.map(comm => actionList.filter(action => action.value === comm));
      let data = [];
    filteredArray.map((item) => {
      return item.map((val) => {
        return data.push(val);
      });
    });
    return data;
    };
    const translation = (keyword) => {
      return props.translationCache?.[keyword] || keyword;
    };
    const hierarchyDropdownChange = (value) => {
      
      handledeviceSelect(value, 'inputList', props.indexDevice);
    };
    // const onModalOk = () => {
    //   setTreeVisible(false);
    // };
    // const onModalCancel = () => {
    //   setTreeVisible(false);
    // };
    // const hierarchyDropdownChanged = (value) => {
    //   setCheckedValue(value);
    // };
    // const onModalsOk = (e) => {
    //   e.preventDefault();
    //   handlePickyChange(checkedValue);
    //   setVisibleTree(false);
    // };
    // const onModalsCancel = () => {
    //   setVisibleTree(false);
    // };
    // const onTree = (arr) => {
    //   if (arr && Array.isArray(arr)) {
    //     return arr.map(obj => 
    //       obj && Array.isArray(obj.children)
    //         ? { ...obj, children: onTree(obj.children) }
    //         : { ...obj, checkable: true }
    //     );
    //   }
    //   return arr;
    // };
    const { config, Methods } = props;
    const {
      inputList,
      conif,
      conelseif,
      conelse,
      elsifLength,
      elseList,
      ruleType,
      mailRecipients,
      rulebody,
      url,
      // Group,
      deviceTypeList,
      onContinous,
      PMvisibleDT,
      rootCausevisibleDT,
      recommandationVisibleDT,
      PMElsevisibleDT,
      rootcauseElsevisibleDT,
      recommandationElsevisibleDT,
      parametersList,
      NumberOfNotifications
      // disabledParamTypeDevice
    } = config;
    const {
      handleParameterSelect,
      handleDelay,
      handleFrequency,
      checkonChange,
      handleTagSelect,
      handleInputChange,
      handleAddClick,
      // handleRuleType,
      handleRecipientList,
      handleNotificationChange,
      handleRulebody,
      handleurl,
      // handlePickyChange,
      // handleRadioButton,
      handleContinous,
      handleRemoveClick,
      handleVisibleChange,
      handlePopoverOnclick,
      handleTextAreaChange,
      handleConditionchange
      // handleparameterTypeSelect
    } = Methods;
     const contentBgColor = props && props.themeValue && props.themeValue.components && props.themeValue.components.Menu && props.themeValue.components.Menu.colorBgContainer;

    return (
      <StyledAppdiv contentBgColor={contentBgColor}>
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            <a
              style={{ marginTop: '5px' }}
              onClick={() => navigate('/rubus/DeviceTypeRuleExclusion')}
            >
              {translation('Redirect to devicetype settings')}
            </a>
            </div>
            <RuleTypeSelectionDiv>
            <div style={{ marginRight: '12%', marginLeft: '10px' }}>
              <BlockedLabelBlack>{translation(constants.select_group)}</BlockedLabelBlack>
              <Select
                placeholder="Select Group"
                style={{ width: '120px', display: 'inline-block' }}
                value={group}
                onChange={(value) => handleRuleType(value, 'Group')}
              >
                {groupList && Array.isArray(groupList) && groupList.map((group, index) => (
                  <Option key={index} value={group.Code}>
                    {translation(group.Name)}
                  </Option>
                ))}
              </Select>
            </div>
            </RuleTypeSelectionDiv>
        <>
        {conif
            ? inputList.map((x, i) => {
                return (
                  <Boxdiv key={`if${i}`}>
                    {i === 0 && (
                      <div style={{ display: 'block' }}>
                        <BlockedLabelBlack>{`if`}</BlockedLabelBlack>
                      </div>
                    )}
                    {i > 0 && (
                      <div style={{ marginRight: '10px 0px' }}>
                        <ConditionSelect
                          name="operater"
                          style={{ marginBottom: '25px' }}
                          placeholder={translation(constants.selectCondition)}
                          
                          value={x['54765'] === '' ? undefined : x['54765']}
                          onChange={(e) => handleConditionchange(e, i, 'inputList')}
                        >
                          <Option value="&&">AND</Option>
                          <Option value="||">OR</Option>
                        </ConditionSelect>
                      </div>
                    )}
                    <ParameterSelect
                      name="parameterName"
                      placeholder={translation(constants.ParameterType)}
                      
                      value={props.parameterName}
                      onChange={(value) => handleParameterSelect(value, i, 'inputList')}
                    >
                      {props.parameterChangeList &&
                        Array.isArray(props.parameterChangeList) &&
                        props.parameterChangeList.map((parameter, j) => (
                          <Option key={`ifdeviceList${j}`} value={parameter.ParameterType}>
                            {parameter.ParameterType}
                          </Option>
                        ))}
                    </ParameterSelect>
                    <DeviceSelect
                      placeholder={translation(constants.selectdevicetype)}
                      
                      value={x.deviceType === '' ? undefined : x.deviceType}
                      onChange={hierarchyDropdownChange}
                    >
                      {deviceTypeList &&
                        Array.isArray(deviceTypeList) &&
                        deviceTypeList.map((deviceType, j) => (
                          <Option key={`ifdeviceTypeList${j}`} value={deviceType.AliasCode}>
                            {deviceType.Name}
                          </Option>
                        ))}
                    </DeviceSelect>
                    <TagNameSelect
                      showSearch
                      name="tagName"
                      placeholder={translation(constants.selectparameters)}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      value={x && x.tagName ? `${x.tagName}` : undefined}
                      onChange={(e) => handleTagSelect(e, i, 'inputList')}
                    >
                      {parametersList &&
                        Array.isArray(parametersList) &&
                        parametersList.filter(
                          (param) =>
                            param.ParameterDescription && param.ParameterDescription.trim() !== ''
                        ).map((param, j) => (
                          <Option key={`inputTagname${i}${j}`} value={param.Code}>
                            {translation(param.ParameterDescription)}
                          </Option>
                        ))}
                    </TagNameSelect>
                    <OperaterSelect
                      name="operater"
                      
                      placeholder={translation(constants.selectoperator)}
                      value={x.operater === '' ? undefined : x.operater}
                      onChange={(e) => handleInputChange(e, i, 'select', 'inputList')}
                    >
                      {Operator && Array.isArray(Operator) && Operator.map((item, index) => (
                        props.parameterName === 'Operational' ? (
                          <Option key={index} value={item.value}>
                            {item.key}
                          </Option>
                        ) : null
                      ))}
                      {props.parameterName !== 'Operational' && (
                        <Option value="==" title="EqualTo">
                          {`EqualTo (==)`}
                        </Option>
                      )}
                    </OperaterSelect>
                    <ValueInput
                      
                      name="value"
                      maxLength={6}
                      placeholder={translation(constants.value)}
                      value={x.value}
                      onChange={(e) => handleInputChange(e, i, 'input', 'inputList')}
                    />
                    {inputList.length !== 1 && (
                      <MarginRightButton
                        
                        onClick={() => handleRemoveClick(i, 'inputList')}
                      >
                        <DeleteOutlined />
                      </MarginRightButton>
                    )}
                    {inputList.length - 1 === i && (
                      <LogicAddButton
                        type={'primary'}
                        
                        onClick={() => handleAddClick('inputList', config.ruleType)}
                      >
                        {translation(constants.add)}
                      </LogicAddButton>
                    )}
                    <ButtonBoxDiv>
                      {inputList.length - 1 === i && (
                        <Fragment>
                          <Popover
                            content={
                              <div>
                                <TextArea
                                  value={inputList[i]?.preventive || ''}
                                  rows={5}
                                  maxLength="150"
                                  onChange={(e) => handleTextAreaChange(e, i, 'inputList', 'preventive')}
                                />
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer' }}
                                  onClick={() => handlePopoverOnclick(i, 'inputList', 'close', 'preventive', 'PMvisibleDT')}
                                >
                                  {translation('Cancel')}
                                </span>
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                  onClick={() => handlePopoverOnclick(i, 'inputList', 'ok', 'PMvisibleDT')}
                                >
                                  {translation('Ok')}
                                </span>
                              </div>
                            }
                            open={PMvisibleDT}
                            onOpenChange={(value) => handleVisibleChange(value, 'PMvisibleDT')}
                            title={translation(constants.preventivemeasure)}
                            trigger="click"
                          >
                            <TextParagraph>
                              {translation(constants.preventivemeasure)}
                            </TextParagraph>
                            {inputList[i]?.preventive?.length > 0 && (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            )}
                          </Popover>
                          <Popover
                            content={
                              <div>
                                <TextArea
                                  value={inputList[i]?.rootcause || ''}
                                  rows={5}
                                  maxLength="150"
                                  onChange={(e) => handleTextAreaChange(e, i, 'inputList', 'rootcause')}
                                />
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer' }}
                                  onClick={() => handlePopoverOnclick(i, 'inputList', 'close', 'rootcause', 'rootCausevisibleDT')}
                                >
                                  {translation('Cancel')}
                                </span>
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                  onClick={() => handlePopoverOnclick(i, 'inputList', 'ok', 'rootCausevisibleDT')}
                                >
                                  {translation('Ok')}
                                </span>
                              </div>
                            }
                            open={rootCausevisibleDT}
                            onOpenChange={(value) => handleVisibleChange(value, 'rootCausevisibleDT')}
                            title={translation(constants.rootcauseanalysis)}
                            trigger="click"
                          >
                            <TextParagraph>
                              {translation(constants.rootcauseanalysis)}
                            </TextParagraph>
                            {inputList[i]?.rootcause?.length > 0 && (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            )}
                          </Popover>
                          <Popover
                            content={
                              <div>
                                <TextArea
                                  value={inputList[i]?.recommandation || ''}
                                  rows={5}
                                  maxLength="150"
                                  onChange={(e) => handleTextAreaChange(e, i, 'inputList', 'recommandation')}
                                />
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer' }}
                                  onClick={() => handlePopoverOnclick(i, 'inputList', 'close', 'recommandation', 'recommandationVisibleDT')}
                                >
                                  {translation('Cancel')}
                                </span>
                                <span
                                  style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                  onClick={() => handlePopoverOnclick(i, 'inputList', 'ok', 'recommandationVisibleDT')}
                                >
                                  {translation('Ok')}
                                </span>
                              </div>
                            }
                            open={recommandationVisibleDT}
                            onOpenChange={(value) => handleVisibleChange(value, 'recommandationVisibleDT')}
                            title={translation(constants.recomandations)}
                            trigger="click"
                          >
                            <TextParagraph>
                              {translation(constants.recomandations)}
                              {inputList[i]?.recommandation?.length > 0 && (
                                <span style={{ color: '#60c40e' }}>
                                  <CheckCircleOutlined />
                                </span>
                              )}
                            </TextParagraph>
                          </Popover>
                        </Fragment>
                      )}
                    </ButtonBoxDiv>
                    {i === inputList.length - 1 && (
                      <div>
                        <Row>
                          <Col span={10}>
                            <ActionSelectionDiv>
                              <BlockedLabelBlack>
                                {translation(constants.action)}
                                <span style={{ color: 'red' }}>*</span> </BlockedLabelBlack>
                              <ActionCheckbox
                                options={data}
                                value={config.inputList[i]?.action}
                                onChange={(checkedValues) => {
                                  checkonChange(checkedValues, 'inputList', i);
                                }}
                              />
                              <Popover placement="top" title={'Delay'}>
                                <TimePicker
                                  style={{ margin: '10px' }}
                                  defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                  value={
                                    config.inputList &&
                                    config.inputList[i] &&
                                    config.inputList[i]['delay'] === undefined
                                      ? dayjs('00:00:00', 'HH:mm:ss')
                                      : dayjs(config.inputList[i]['delay'][1], 'HH:mm:ss')
                                  }
                                  onChange={(e) => handleDelay(e, 'inputList', i)}
                                  placeholder={translation(constants.selectDelay)}
                                  allowClear={false}
                                  
                                />
                              </Popover>
                              {config.inputList &&
                              config.inputList[config.inputList.length - 1] &&
                              config.inputList[config.inputList.length - 1].cation &&
                              config.inputList[config.inputList.length - 1].action.indexOf('RestAPI') > -1 ? (
                                <Input
                                  style={{ width: '55%', marginTop: '2%' }}
                                  placeholder="Enter Url"
                                  name="value"
                                  value={url}
                                  onChange={(e) => handleurl(e, 'url')}
                                />
                              ) : null}
                            </ActionSelectionDiv>
                          </Col>
                        </Row>
                      </div>
                    )}
                    {i === inputList.length - 1 && (
                      <div>
                        <Row>
                          <Col span={10}>
                            <ActionSelectionDiv>
                              <BlockedLabelBlack>
                                {translation(constants.NotificationType)}
                              </BlockedLabelBlack>
                              {config.ruleType !== 'downTime' && (
                                <OnchangeCheckbox
                                  checked={onContinous}
                                  onChange={(value) => handleContinous(value)}
                                >
                                  {translation(constants.onContinous)}
                                </OnchangeCheckbox>
                              )}
                              <Popover placement="top" title={'Frequency'}>
                                <TimePicker
                                  // disabled={onContinous === true ? false : true}
                                  style={{ margin: '10px' }}
                                  defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                  value={
                                    config.inputList &&
                                    config.inputList[i] &&
                                    config.inputList[i]['frequency'] === undefined
                                      ? dayjs('00:00:00', 'HH:mm:ss')
                                      : dayjs(config.inputList[i]['frequency'][1], 'HH:mm:ss')
                                  }
                                  onChange={(e) => handleFrequency(e, 'inputList', i)}
                                  placeholder={translation(constants.selectFrequency)}
                                  allowClear={false}
                                  
                                />
                              </Popover>
                              {config.inputList &&
                              config.inputList[config.inputList.length - 1] &&
                              config.inputList[config.inputList.length - 1].cation &&
                              config.inputList[config.inputList.length - 1].action.indexOf('RestAPI') > -1 ? (
                                <Input
                                  style={{ width: '55%', marginTop: '2%' }}
                                  placeholder="Enter Url"
                                  name="value"
                                  value={url}
                                  onChange={(e) => handleurl(e, 'url')}
                                />
                              ) : null}
                            </ActionSelectionDiv>
                          </Col>
                        </Row>
                      </div>
                    )}
                    {i === inputList.length - 1 && (
                      <div>
                        <Row>
                          <Col span={7}>
                            <BlockedLabelBlack>
                              {translation(constants.noOfNotifications)}
                            </BlockedLabelBlack>
                            <Input
                              type="number"
                              onKeyDown={(e) => {
                                if ([8].includes(e.keyCode)) {
                                  return;
                                }
                                if (
                                  (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                  (e.keyCode < 96 || e.keyCode > 105)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder={translation('No.of Notifications')}
                              value={NumberOfNotifications}
                              style={{ width: '100%', display: 'inline-block' }}
                              onChange={(value) => handleNotificationChange(value, 'NumberOfNotifications')}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={7}>
                            <BlockedLabelBlack>
                              {translation(constants.members)}
                            </BlockedLabelBlack>
                            <Select
                              placeholder={translation('RecipientList')}
                              mode="multiple"
                              value={mailRecipients}
                              style={{ width: '100%', display: 'inline-block' }}
                              onChange={(value) => handleRecipientList(value, 'mailRecipients')}
                            >
                              {recipientList &&
                                Array.isArray(recipientList) &&
                                recipientList.map((item, index) => (
                                  <Option key={index} value={item.Email}>
                                    {item.FirstName} {item.LastName}
                                  </Option>
                                ))}
                            </Select>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Boxdiv>
                );
              })
            : null}
          {/* -------------------- Else if */}
          {conelseif
              ? elsifLength.map((elsepropName, index) => {
                  return config[elsepropName].map((x, i) => {
                    return (
                      <Boxdiv key={`${index}${i}`}>
                        {i === 0 && <BlockedLabelBlack>else if</BlockedLabelBlack>}
                        {i > 0 && (
                          <ConditionSelect
                            
                            name="operater"
                            value={x['54765'] === '' ? undefined : x['54765']}
                            placeholder={translation(constants.selectCondition)}
                            onChange={(e) => handleConditionchange(e, i, elsepropName)}
                          >
                            <Option value="&&">{translation('AND')}</Option>
                            <Option value="||">{translation('OR')}</Option>
                          </ConditionSelect>
                        )}
                        <ParameterSelect
                          name="parameterName"
                          placeholder={translation(constants.ParameterType)}
                          
                          value={props.parameterName}
                          onChange={(value) => handleParameterSelect(value, i, elsepropName)}
                        >
                          {props.parameterChangeList &&
                            Array.isArray(props.parameterChangeList) &&
                            props.parameterChangeList.map((parameter, j) => (
                              <Option key={`ifdeviceList${j}`} value={parameter.ParameterType}>
                                {parameter.ParameterType}
                              </Option>
                            ))}
                        </ParameterSelect>
                        <DeviceSelect
                          placeholder={translation(constants.selectdevicetype)}
                          
                          value={x.deviceType === '' ? undefined : x.deviceType}
                          onChange={hierarchyDropdownChange}
                        >
                          {deviceTypeList &&
                            Array.isArray(deviceTypeList) &&
                            deviceTypeList.map((deviceType, j) => (
                              <Option key={`ifdeviceTypeList${j}`} value={deviceType.AliasCode}>
                                {deviceType.Name}
                              </Option>
                            ))}
                        </DeviceSelect>
                        <TagNameSelect
                          showSearch
                          name="tagName"
                          
                          placeholder={translation(constants.selectparameters)}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          value={x && x.tagName ? `${x.tagName}` : undefined}
                          onChange={(e) => handleTagSelect(e, i, elsepropName)}
                        >
                          {parametersList &&
                            Array.isArray(parametersList) &&
                            parametersList.filter(
                              (param) =>
                                param.ParameterDescription && param.ParameterDescription.trim() !== ''
                            ).map((param, j) => (
                              <Option key={`inputTagname${i}${j}`} value={param.Code}>
                                {translation(param.ParameterDescription)}
                              </Option>
                            ))}
                        </TagNameSelect>
                        <OperaterSelect
                          name="operater"
                          
                          placeholder={translation(constants.selectoperator)}
                          value={x.operater === '' ? undefined : x.operater}
                          onChange={(e) => handleInputChange(e, i, 'select', elsepropName)}
                        >
                          {Operator.map((item, j) => (
                            props.parameterName === 'Operational' ? (
                              <Option key={j} value={item.value}>
                                {item.key}
                              </Option>
                            ) : null
                          ))}
                          {props.parameterName !== 'Operational' && (
                            <Option value="==" title="EqualTo">
                              {`EqualTo (==)`}
                            </Option>
                          )}
                        </OperaterSelect>
                        <ValueInput
                          
                          name="value"
                          maxLength={6}
                          placeholder={translation(constants.value)}
                          value={x.value}
                          onChange={(e) => handleInputChange(e, i, 'input', elsepropName)}
                        />
                        <ButtonBoxDiv>
                          {config[elsepropName].length !== 1 && (
                            <MarginRightButton
                              
                              onClick={() => handleRemoveClick(i, elsepropName)}
                            >
                              <DeleteOutlined />
                            </MarginRightButton>
                          )}
                          {config[elsepropName].length - 1 === i && (
                            <Fragment>
                              <LogicAddButton
                                type={'primary'}
                                
                                onClick={() => handleAddClick(elsepropName, ruleType)}
                              >
                                {translation(constants.add )}
                              </LogicAddButton>
                              <Popover
                                content={
                                  <div>
                                    <TextArea
                                      value={config[elsepropName][i]['preventive']}
                                      rows={5}
                                      maxLength="150"
                                      onChange={(e) =>
                                        handleTextAreaChange(e, i, elsepropName, 'preventive')
                                      }
                                    />
                                    <span
                                      style={{ color: '#1890ff', cursor: 'pointer' }}
                                      onClick={() => {
                                        handlePopoverOnclick(
                                          i,
                                          elsepropName,
                                          'close',
                                          'preventive',
                                          `PMvisibleDT${elsepropName}`
                                        );
                                      }}
                                    >
                                      {translation('Cancel')}
                                    </span>
                                    <span
                                      style={{
                                        color: '#1890ff',
                                        cursor: 'pointer',
                                        float: 'right'
                                      }}
                                      onClick={() => {
                                        handlePopoverOnclick(
                                          i,
                                          elsepropName,
                                          'ok',
                                          `PMvisibleDT${elsepropName}`
                                        );
                                      }}
                                    >
                                      {translation('Ok')}
                                    </span>
                                  </div>
                                }
                                open={config[`PMvisibleDT${elsepropName}`]}
                                onOpenChange={(value) =>
                                  handleVisibleChange(value, `PMvisibleDT${elsepropName}`)
                                }
                                title={translation(constants.preventivemeasure)}
                                trigger="click"
                              >
                                <TextParagraph>
                                  {translation(constants.preventivemeasure)}
                                </TextParagraph>
                                {config[elsepropName][i]['preventive'] &&
                                config[elsepropName][i]['preventive'].length > 0 ? (
                                  <span style={{ color: '#60c40e' }}>
                                    <CheckCircleOutlined />
                                  </span>
                                ) : null}
                              </Popover>
                              <Popover
                                content={
                                  <div>
                                    <TextArea
                                      value={config[elsepropName][i]['rootcause']}
                                      rows={5}
                                      maxLength="150"
                                      onChange={(e) =>
                                        handleTextAreaChange(e, i, elsepropName, 'rootcause')
                                      }
                                    />
                                    <span
                                      style={{ color: '#1890ff', cursor: 'pointer' }}
                                      onClick={() => {
                                        handlePopoverOnclick(
                                          i,
                                          elsepropName,
                                          'close',
                                          'rootcause',
                                          `rootCausevisibleDT${elsepropName}`
                                        );
                                      }}
                                    >
                                      {translation('Cancel')}
                                    </span>
                                    <span
                                      style={{
                                        color: '#1890ff',
                                        cursor: 'pointer',
                                        float: 'right'
                                      }}
                                      onClick={() => {
                                        handlePopoverOnclick(
                                          i,
                                          elsepropName,
                                          'ok',
                                          `rootCausevisibleDT${elsepropName}`
                                        );
                                      }}
                                    >
                                      {translation('Ok')}
                                    </span>
                                  </div>
                                }
                                open={config[`rootCausevisibleDT${elsepropName}`]}
                                onOpenChange={(value) =>
                                  handleVisibleChange(value, `rootCausevisibleDT${elsepropName}`)
                                }
                                title={translation(constants.rootcauseanalysis)}
                                trigger="click"
                              >
                                <TextParagraph>
                                  {translation(constants.rootcauseanalysis)}
                                </TextParagraph>
                                {config[elsepropName][i]['rootcause'] &&
                                config[elsepropName][i]['rootcause'].length > 0 ? (
                                  <span style={{ color: '#60c40e' }}>
                                    <CheckCircleOutlined />
                                  </span>
                                ) : null}
                              </Popover>
                              <Popover
                                content={
                                  <div>
                                    <TextArea
                                      value={config[elsepropName][i]['recommandation']}
                                      rows={5}
                                      maxLength="150"
                                      onChange={(e) =>
                                        handleTextAreaChange(e, i, elsepropName, 'recommandation')
                                      }
                                    />
                                    <span
                                      style={{ color: '#1890ff', cursor: 'pointer' }}
                                      onClick={() => {
                                        handlePopoverOnclick(
                                          i,
                                          elsepropName,
                                          'close',
                                          'recommandation',
                                          `recomandationsvisibleDT${elsepropName}`
                                        );
                                      }}
                                    >
                                      {translation('Cancel')}
                                    </span>
                                    <span
                                      style={{
                                        color: '#1890ff',
                                        cursor: 'pointer',
                                        float: 'right'
                                      }}
                                      onClick={() => {
                                        handlePopoverOnclick(
                                          i,
                                          elsepropName,
                                          'ok',
                                          `recomandationsvisibleDT${elsepropName}`
                                        );
                                      }}
                                    >
                                      {translation('Ok')}
                                    </span>
                                  </div>
                                }
                                open={config[`recomandationsvisibleDT${elsepropName}`]}
                                onOpenChange={(value) =>
                                  handleVisibleChange(value, ` recomandationsvisibleDT${elsepropName}`)
                                }
                                title={translation(constants.recomandations)}
                                trigger="click"
                              >
                                <TextParagraph>
                                  {translation(constants.recomandations)}
                                </TextParagraph>
                              </Popover>
                              {config[elsepropName][i]['recommandation'] &&
                              config[elsepropName][i]['recommandation'].length > 0 ? (
                                <span style={{ color: '#60c40e' }}>
                                  <CheckCircleOutlined />
                                </span>
                              ) : null}
                            </Fragment>
                          )}
                        </ButtonBoxDiv>
                        {config[elsepropName].length - 1 === i && (
                          <ActionSelectionDiv>
                            <BlockedLabelBlack>
                              {translation(constants.action)}
                              <span style={{ color: 'red' }}>*</span>
                            </BlockedLabelBlack>
                            <ActionCheckbox
                              options={data}
                              value={config[elsepropName][i]['action']}
                              onChange={(checkedValues) => {
                                checkonChange(checkedValues, elsepropName, i);
                              }}
                            />
                            <Popover placement="top" title={'Delay'}>
                              <TimePicker
                                style={{ margin: '10px' }}
                                defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                value={
                                  config[elsepropName][i]['delay'] === undefined
                                    ? undefined
                                    : dayjs(config[elsepropName][i]['delay'][1], 'HH:mm:ss')
                                }
                                onChange={(e) => handleDelay(e, elsepropName, i)}
                                placeholder={translation(constants.selectDelay)}
                                
                                allowClear={false}
                              />
                            </Popover>
                            <Popover placement="top" title={'Frequency'}>
                              <TimePicker
                                // disabled={onContinous === true ? false : true}
                                style={{ margin: '10px' }}
                                defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                                value={
                                  config[elsepropName][i]['frequency'] === undefined
                                    ? undefined
                                    : dayjs(config[elsepropName][i]['frequency'][1], 'HH:mm:ss')
                                }
                                onChange={(e) => handleFrequency(e, elsepropName, i)}
                                placeholder={translation(constants.selectFrequency)}
                                
                                allowClear={false}
                              />
                            </Popover>
                            {config &&
                            config[elsepropName][i] &&
                            config[elsepropName][i].action.indexOf('RestAPI') > -1 ? (
                              <Input
                                style={{ width: '55%', marginTop: '2%' }}
                                placeholder={translation('Enter Url')}
                                name="value"
                                value={url}
                                onChange={(e) => handleurl(e, 'url')}
                              />
                            ) : null}
                          </ActionSelectionDiv>
                        )}
                        {i === config[elsepropName].length - 1 && (
                          <div>
                            <Row>
                              <Col span={7}>
                                <BlockedLabelBlack>
                                  {translation(constants.noOfNotifications)}
                                </BlockedLabelBlack>
                                <Input
                                  type="number"
                                  onKeyDown={(e) => {
                                    if ([8].includes(e.keyCode)) {
                                      return;
                                    }
                                    if (
                                      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                      (e.keyCode < 96 || e.keyCode > 105)
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  placeholder={translation('No.of Notifications')}
                                  value={NumberOfNotifications}
                                  style={{ width: '100%', display: 'inline-block' }}
                                  onChange={(value) =>
                                    handleNotificationChange(value, 'NumberOfNotifications')
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col span={7}>
                                <BlockedLabelBlack>
                                  {translation(constants.members)}
                                </BlockedLabelBlack>
                                <Select
                                  placeholder={translation('RecipientList')}
                                  mode="multiple"
                                  value={mailRecipients}
                                  style={{ width: '90%', display: 'inline-block' }}
                                  onChange={(value) => handleRecipientList(value, 'mailRecipients')}
                                >
                                  {recipientList &&
                                    Array.isArray(recipientList) &&
                                    recipientList.map((item, index) => (
                                      <Option key={index} value={item.Email}>
                                        {item.FirstName} {item.LastName}
                                      </Option>
                                    ))}
                                </Select>
                              </Col>
                              <Col span={6}>
                                <BlockedLabelBlack>
                                  {translation(constants.bodymessage)}
                                </BlockedLabelBlack>
                                <TextArea
                                  
                                  name="value"
                                  rows={1}
                                  value={rulebody}
                                  placeholder={translation(constants.text)}
                                  onChange={(e) => handleRulebody(e, ' rulebody')}
                                />
                              </Col>
                            </Row>
                          </div>
                        )}
                      </Boxdiv>
                    );
                  });
                })
              : null}
          {/* -------------------- Else */}
          {conelse
              ? elseList.map((x, i) => {
                  return (
                    <Boxdiv key={`else${i}`}>
                      {i === 0 && <BlockedLabelBlack>else</BlockedLabelBlack>}
                      {i > 0 && (
                        <ConditionSelect
                          name="operater"
                          
                          value={x['54765'] === '' ? undefined : x['54765']}
                          placeholder={translation(constants.selectCondition)}
                          onChange={(e) => handleConditionchange(e, i, 'elseList')}
                        >
                          <Option value="&&">{translation('AND')}</Option>
                          <Option value="||">{translation('OR')}</Option>
                        </ConditionSelect>
                      )}
                      <ParameterSelect
                        name="parameterName"
                        placeholder={translation(constants.ParameterType)}
                        
                        value={props.parameterName}
                        onChange={(value) => handleParameterSelect(value, i, 'elseList')}
                      >
                        {props.parameterChangeList &&
                          Array.isArray(props.parameterChangeList) &&
                          props.parameterChangeList.map((parameter, j) => (
                            <Option key={`ifdeviceList${j}`} value={parameter.ParameterType}>
                              {parameter.ParameterType}
                            </Option>
                          ))}
                      </ParameterSelect>
                      <DeviceSelect
                        placeholder={translation(constants.selectdevicetype)}
                        
                        value={x.deviceType === '' ? undefined : x.deviceType}
                        onChange={hierarchyDropdownChange}
                      >
                        {deviceTypeList &&
                          Array.isArray(deviceTypeList) &&
                          deviceTypeList.map((deviceType, j) => (
                            <Option key={`ifdeviceTypeList${j}`} value={deviceType.AliasCode}>
                              {deviceType.Name}
                            </Option>
                          ))}
                      </DeviceSelect>
                      <TagNameSelect
                        showSearch
                        name="tagName"
                        
                        placeholder={translation(constants.selectparameters)}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={x && x.tagName ? `${x.tagName}` : undefined}
                        onChange={(e) => handleTagSelect(e, i, 'elseList')}
                      >
                        {parametersList &&
                          Array.isArray(parametersList) &&
                          parametersList.filter(
                            (param) =>
                              param.ParameterDescription && param.ParameterDescription.trim() !== ''
                          ).map((param, j) => (
                            <Option key={`inputTagname${i}${j}`} value={param.Code}>
                              {translation(param.ParameterDescription)}
                            </Option>
                          ))}
                      </TagNameSelect>
                      <OperaterSelect
                        name="operater"
                        
                        placeholder={translation(constants.selectoperator)}
                        value={x.operater === '' ? undefined : x.operater}
                        onChange={(e) => handleInputChange(e, i, 'select', 'elseList')}
                      >
                        {Operator.map((item, j) => (
                          props.parameterName === 'Operational' ? (
                            <Option key={j} value={item.value}>
                              {item.key}
                            </Option>
                          ) : null
                        ))}
                        {props.parameterName !== 'Operational' && (
                          <Option value="==" title="EqualTo">
                            {`EqualTo (==)`}
                          </Option>
                        )}
                      </OperaterSelect>
                      <ValueInput
                        
                        name="value"
                        maxLength={6}
                        placeholder={translation(constants.value)}
                        value={x.value}
                        onChange={(e) => handleInputChange(e, i, 'input', 'elseList')}
                      />
                      <ButtonBoxDiv>
                        {elseList.length !== 1 && (
                          <MarginRightButton
                            
                            onClick={() => handleRemoveClick(i, 'elseList')}
                            icon={<DeleteOutlined />}
                          >
                            <DeleteOutlined />
                          </MarginRightButton>
                        )}
                        {elseList.length - 1 === i && (
                          <Fragment>
                            <LogicAddButton
                              type={'primary'}
                              
                              onClick={() => handleAddClick('elseList', handleAddClick)}
                            >
                              {translation(constants.add)}
                            </LogicAddButton>
                            <Popover
                              content={
                                <div>
                                  <TextArea
                                    value={elseList[i]['preventive']}
                                    rows={5}
                                    maxLength="150"
                                    onChange={(e) =>
                                      handleTextAreaChange(e, i, 'elseList', 'preventive')
                                    }
                                  />
                                  <span
                                    style={{ color: '#1890ff', cursor: 'pointer' }}
                                    onClick={() => {
                                      handlePopoverOnclick(
                                        i,
                                        'elseList',
                                        'close',
                                        'preventive',
                                        `PMElsevisibleDT`
                                      );
                                    }}
                                  >
                                    {translation('Cancel')}
                                  </span>
                                  <span
                                    style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                    onClick={() => {
                                      handlePopoverOnclick(i, 'elseList', 'ok', `PMElsevisibleDT`);
                                    }}
                                  >
                                    {translation('Ok')}
                                  </span>
                                </div>
                              }
                              open={PMElsevisibleDT}
                              onOpenChange={(value) => handleVisibleChange(value, `PMElsevisibleDT`)}
                              title={translation(constants.preventivemeasure)}
                              trigger="click"
                            >
                              <TextParagraph>
                                {translation(constants.preventivemeasure)}
                              </TextParagraph>
                              {elseList[i]['preventive'] && elseList[i]['preventive'].length > 0 ? (
                                <span style={{ color: '#60c40e' }}>
                                  <CheckCircleOutlined />
                                </span>
                              ) : null}
                            </Popover>
                            <Popover
                              content={
                                <div>
                                  <TextArea
                                    value={elseList[i]['rootcause']}
                                    rows={4}
                                    maxLength="150"
                                    onChange={(e) =>
                                      handleTextAreaChange(e, i, 'elseList', 'rootcause')
                                    }
                                  />
                                  <span
                                    style={{ color: '#1890ff', cursor: 'pointer' }}
                                    onClick={() => {
                                      handlePopoverOnclick(
                                        i,
                                        'elseList',
                                        'close',
                                        'rootcause',
                                        `rootcauseElsevisibleDT`
                                      );
                                    }}
                                  >
                                    {translation('Cancel')}
                                  </span>
                                  <span
                                    style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                    onClick={() => {
                                      handlePopoverOnclick(
                                        i,
                                        'elseList',
                                        'ok',
                                        `rootcauseElsevisibleDT`
                                      );
                                    }}
                                  >
                                    {translation('Ok')}
                                  </span>
                                </div>
                              }
                              open={rootcauseElsevisibleDT}
                              onOpenChange={(value) =>
                                handleVisibleChange(value, `rootcauseElsevisibleDT`)
                              }
                              title={translation(constants.rootcauseanalysis)}
                              trigger="click"
                            >
                              <TextParagraph>
                                {translation(constants.rootcauseanalysis)}
                              </TextParagraph>
                              {elseList[i]['rootcause'] && elseList[i]['rootcause'].length > 0 ? (
                                <span style={{ color: '#60c40e' }}>
                                  <CheckCircleOutlined />
                                </span>
                              ) : null}
                            </Popover>
                            <Popover
                              content={
                                <div>
                                  <TextArea
                                    value={elseList[i]['recommandation']}
                                    rows={4}
                                    maxLength="150"
                                    onChange={(e) =>
                                      handleTextAreaChange(e, i, 'elseList', 'recommandation')
                                    }
                                  />
                                  <span
                                    style={{ color: '#1890ff', cursor: 'pointer' }}
                                    onClick={() => {
                                      handlePopoverOnclick(
                                        i,
                                        'elseList',
                                        'close',
                                        'recommandation',
                                        `recommandationElsevisibleDT`
                                      );
                                    }}
                                  >
                                    {translation('Cancel')}
                                  </span>
                                  <span
                                    style={{ color: '#1890ff', cursor: 'pointer', float: 'right' }}
                                    onClick={() => {
                                      handlePopoverOnclick(
                                        i,
                                        'elseList',
                                        'ok',
                                        `recommandationElsevisibleDT`
                                      );
                                    }}
                                  >
                                    {translation('Ok')}
                                  </span>
                                </div>
                              }
                              open={recommandationElsevisibleDT}
                              onOpenChange={(value) =>
                                handleVisibleChange(value, `recommandationElsevisibleDT`)
                              }
                              title={translation(constants.recomandations)}
                              trigger="click"
                            >
                              <TextParagraph>
                                {translation(constants.recomandations)}
                              </TextParagraph>
                            </Popover>
                            {elseList[i]['recommandation'] &&
                            elseList[i]['recommandation'].length > 0 ? (
                              <span style={{ color: '#60c40e' }}>
                                <CheckCircleOutlined />
                              </span>
                            ) : null}
                          </Fragment>
                        )}
                      </ButtonBoxDiv>
                      {elseList .length - 1 === i && (
                        <ActionSelectionDiv>
                          <BlockedLabelBlack>
                            {translation(constants.action)}
                            <span style={{ color: 'red' }}>*</span>
                          </BlockedLabelBlack>
                          <ActionCheckbox
                            options={data}
                            value={config.elseList[i]['action'].map((covert) => {
                              return translation(covert);
                            })}
                            onChange={(checkedValues) => {
                              checkonChange(checkedValues, 'elseList', i);
                            }}
                          />
                          <Popover placement="top" title={'Delay'}>
                            <TimePicker
                              style={{ margin: '10px' }}
                              defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                              value={
                                config.elseList[i]['delay'] === undefined
                                  ? undefined
                                  : dayjs(config.elseList[i]['delay'][1], 'HH:mm:ss')
                              }
                              onChange={(e) => handleDelay(e, 'elseList', i)}
                              placeholder={translation(constants.selectDelay)}
                              
                              allowClear={false}
                            />
                          </Popover>
                          <Popover placement="top" title={'Frequency'}>
                            <TimePicker
                              // disabled={onContinous === true ? false : true}
                              style={{ margin: '10px' }}
                              defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                              value={
                                config.elseList[i]['frequency'] === undefined
                                  ? undefined
                                  : dayjs(config.elseList[i]['frequency'][1], 'HH:mm:ss')
                              }
                              onChange={(e) => handleFrequency(e, 'elseList', i)}
                              placeholder={translation(constants.selectFrequency)}
                              
                              allowClear={false}
                            />
                          </Popover>
                          {config &&
                          config.elseList[i] &&
                          config.elseList[i].action.indexOf('RestAPI') > -1 ? (
                            <Input
                              style={{ width: '55%', marginTop: '2%' }}
                              placeholder="Enter Url"
                              name="value"
                              value={url}
                              onChange={(e) => handleurl(e, 'url')}
                            />
                          ) : null}
                        </ActionSelectionDiv>
                      )}
                      {i === elseList.length - 1 && (
                        <div>
                          <Row>
                            <Col span={7}>
                              <BlockedLabelBlack>
                                {translation(constants.noOfNotifications)}
                              </BlockedLabelBlack>
                              <Input
                                type="number"
                                onKeyDown={(e) => {
                                  if ([8].includes(e.keyCode)) {
                                    return;
                                  }
                                  if (
                                    (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
                                    (e.keyCode < 96 || e.keyCode > 105)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                placeholder={translation('No.of Notifications')}
                                value={NumberOfNotifications}
                                style={{ width: '100%', display: 'inline-block' }}
                                onChange={(value) =>
                                  handleNotificationChange(value, 'NumberOfNotifications')
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col span={7}>
                              <BlockedLabelBlack>
                                {translation(constants.members)}
                              </BlockedLabelBlack>
                              <Select
                                placeholder={translation('RecipientList')}
                                value={mailRecipients}
                                mode="multiple"
                                style={{ width: '90%', display: 'inline-block' }}
                                onChange={(value) => handleRecipientList(value, 'mailRecipients')}
                              >
                                {recipientList &&
                                  Array.isArray(recipientList) &&
                                  recipientList.map((item, index) => (
                                    <Option key={index} value={item.Email}>
                                      {item.FirstName} {item.LastName}
                                    </Option>
                                  ))}
                              </Select>
                            </Col>
                            <Col span={5}>
                              <BlockedLabelBlack>
                                {translation(constants.bodymessage)}
                              </BlockedLabelBlack>
                              <TextArea
                                
                                name="value"
                                rows={1}
                                value={rulebody}
                                placeholder={translation(constants.text)}
                                onChange={(e) => handleRulebody(e, 'rulebody')}
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Boxdiv>
                  );
                })
              : null}
          <BlankDiv></BlankDiv>
        </>
      </StyledAppdiv>
    );
};
const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer
  };
};

export default connect(mapStateToProps)(DeviceTypeRule);
